import { render } from "./uploadCom.vue?vue&type=template&id=7d858582"
import script from "./uploadCom.vue?vue&type=script&lang=js"
export * from "./uploadCom.vue?vue&type=script&lang=js"

import "./uploadCom.vue?vue&type=style&index=0&id=7d858582&lang=postcss"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__